import React, {Component} from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import Column from "./../../../../components/column/column";
import Row from "./../../../../components/row/row";
import contactSectionStyle from "./contactSection.module.pcss";
import "./../../../../../static/styles/font-awesome-4.7.0/css/font-awesome.min.css";

const ContactSection = ({translations}) => {
  return (
    <Row displayFlex={false} rowWrapperClassName={contactSectionStyle.contactSection}>
      <div className={contactSectionStyle.getInTouch}>
        <Markdown className={contactSectionStyle.startTrial} source={translations.startTrial} />
        <Markdown className={contactSectionStyle.startTrialDescription} source={translations.startTrialDescription} />

        <div className={contactSectionStyle.buttons}>
          <Column customColumnClass={contactSectionStyle.column}>
            <a href={translations.emailLink}>
              <Markdown className={contactSectionStyle.downloadButton} source={translations.tryGrudButton} />
              <Markdown source={translations.tryGrud} />
            </a>
          </Column>
          <Column customColumnClass={contactSectionStyle.column}>
            <a target="_blank" href={translations.downloadBrochureLink}>
              <Markdown className={contactSectionStyle.downloadButton} source={translations.contactDownloadBrochure} />
              <Markdown source={translations.downloadPrintBrochure} />
            </a>
          </Column>
        </div>
      </div>

      <div className={contactSectionStyle.contact}>
        <div>
          <a href={translations.phoneLink}>
            <div className={contactSectionStyle.icon}><span><i className="fa fa-phone" /></span></div>
            <p>{translations.campudusPhone}</p>
          </a>
        </div>
        <div>
          <a href={translations.emailLink}>
            <div className={contactSectionStyle.icon}><span><i className="fa fa-envelope" /></span></div>
            <Markdown className={contactSectionStyle.phone} source={translations.email} />
          </a>
        </div>
      </div>
    </Row>
  )
};

ContactSection.propTypes = {
  translations: PropTypes.object.isRequired,
};

export default ContactSection;



// WEBPACK FOOTER //
// ./src/templates/landing/components/contactSection/contactSection.js